import { createContext } from "react"
import { makeRootController } from "../controllers/_root.controller"

export const RootContextInstance = makeRootController();

RootContextInstance.init();

export const RootContext = createContext(RootContextInstance);